import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useNotification } from "./NotificationContext";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { showToast } = useNotification();

  useEffect(() => {
    // Si une URL de socket est définie dans les variables d'environnement (ex: production sur un autre domaine)
    const socketUrl = process.env.REACT_APP_SOCKET_URL || undefined;

    const newSocket = io(socketUrl, {
      withCredentials: true,
    });
    setSocket(newSocket);

    newSocket.on("connect_error", () => {
      window.dispatchEvent(new Event("backend-down"));
    });

    newSocket.on("nouvelUtilisateur", (data) => {
      showToast(`Nouvel utilisateur : ${data.nom} (${data.role})`, "info");
    });

    newSocket.on("nouveauProspect", (data) => {
      showToast(`Nouveau prospect : ${data.nom} (${data.entreprise})`, "success");
    });

    newSocket.on("nouveauDossier", (data) => {
      showToast(`Nouveau dossier dans le pipe : ${data.title} (${data.reference})`, "info");
    });

    return () => newSocket.disconnect();
  }, [showToast]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};
